/** BCP 47 tags for the app's supported UI languages, used for month labels. */
const MONTH_LABEL_LOCALES: Record<string, string> = {
  en: 'en-US',
  ja: 'ja-JP',
  zh: 'zh-CN',
}

/**
 * Format an ISO month key (`"2026-03"`) as a long display label in the given
 * UI language (`"March 2026"`, `"2026年3月"`). Falls back to the raw key if
 * parsing fails so the UI never crashes on unexpected values.
 */
export const formatMonthLabel = (monthKey: string, language: string): string => {
  const [year, month] = monthKey.split('-').map(Number)
  if (!year || !month) return monthKey
  const locale = MONTH_LABEL_LOCALES[language.split('-')[0]] ?? MONTH_LABEL_LOCALES.en
  return new Date(Date.UTC(year, month - 1, 1)).toLocaleString(locale, { month: 'long', year: 'numeric', timeZone: 'UTC' })
}

/** Returns the month immediately preceding `month` within `months`, or null. */
export const getPreviousMonth = (months: readonly string[], month: string | null): string | null => {
  if (!month) return null
  const idx = months.indexOf(month)
  return idx > 0 ? months[idx - 1] : null
}
